import { featureEnabled } from 'utils';
import template from './appointment_book.html';

angular.module('bb.appointments').component('appointmentBook', {
  controller: AppointmentBookCtrl,
  controllerAs: 'vm',
  template,
  bindings: {
    extAuth: '=',
    setExtAuth: '=',
    appointmentDetails: '<?',
    isListingContact: '<?',
  },
});

AppointmentBookCtrl.$inject = [
  '$rootScope',
  '$scope',
  '$routeParams',
  '$window',
  'ExternalService',
];

function AppointmentBookCtrl(
  $rootScope,
  $scope,
  $routeParams,
  $window,
  ExternalService,
) {
  const vm = this;

  vm.$onInit = function () {
    vm.showDetailsRevamp = featureEnabled(
      'showingDetailsRevampFeaturePhase',
      2,
    );
  };

  vm.isDoneWelcomeFlow = $rootScope.isDoneWelcomeFlow;

  vm.fetchSavedAppointment = data => {
    if (!data) return;
    $scope.$apply(() => {
      if (featureEnabled('showingDetailsRevampFeaturePhase', 2)) {
        const { dashboardId, retsId } = $routeParams;
        if (dashboardId) {
          $window.location.href = `/external/#/dash/${dashboardId}/showing/${data.id}`;
        } else if (retsId) {
          $window.location.href = `/dashboard/#/rets/${retsId}/showing/${data.id}`;
        }
      }
      vm.savedAppointment = data;
    });
  };

  vm.updateAppointment = appointmentId => {
    const { dashboardId } = $routeParams;
    if (dashboardId) {
      ExternalService.getAppointment(dashboardId, appointmentId).then(
        appointment => {
          vm.savedAppointment = appointment.toJSON();
        },
      );
    }
  };

  $rootScope.$watch('isDoneWelcomeFlow', () => {
    vm.isDoneWelcomeFlow = $rootScope.isDoneWelcomeFlow;
  });
}

if (module.hot) {
  module.hot.accept('./appointment_book.module.scss', () => {});
}
